/**
 * Dlaczego rata nie bierze udziału w rozkładzie zmiany należności (reguła R5
 * backendu). Lustro `ScheduleFreezeReason`.
 *
 * Powód jedzie do operatora razem z podglądem harmonogramu, bo dwóch z nich —
 * otwartej płatności online i kwoty niedodatniej — po statusie raty nie widać
 * wcale. Rata nietknięta bez wytłumaczenia wygląda na błąd systemu.
 */
export enum ScheduleFreezeReason {
  /** Opłaconej nie da się zmienić wstecz. */
  PAID = 'PAID',
  /** Anulowana nie jest już należnością. */
  CANCELLED = 'CANCELLED',
  /** Klient trzyma link do płatności z zamrożoną kwotą. */
  OPEN_ONLINE_PAYMENT = 'OPEN_ONLINE_PAYMENT',
  /** Zwrot jest wypłatą do klienta, a nie jego należnością. */
  REFUND = 'REFUND',
  /** Kwota zerowa albo ujemna — udział liczy się proporcjonalnie do kwoty. */
  NON_POSITIVE_AMOUNT = 'NON_POSITIVE_AMOUNT',
}
